function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import { compute as t } from "compute-scroll-into-view";
var o = function o(t) {
  return !1 === t ? {
    block: "end",
    inline: "nearest"
  } : function (t) {
    return t === Object(t) && 0 !== Object.keys(t).length;
  }(t) ? t : {
    block: "start",
    inline: "nearest"
  };
};
function e(e, r) {
  if (!e.isConnected || !function (t) {
    var o = t;
    for (; o && o.parentNode;) {
      if (o.parentNode === document) return !0;
      o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
    }
    return !1;
  }(e)) return;
  var n = function (t) {
    var o = window.getComputedStyle(t);
    return {
      top: parseFloat(o.scrollMarginTop) || 0,
      right: parseFloat(o.scrollMarginRight) || 0,
      bottom: parseFloat(o.scrollMarginBottom) || 0,
      left: parseFloat(o.scrollMarginLeft) || 0
    };
  }(e);
  if (function (t) {
    return "object" == _typeof(t) && "function" == typeof t.behavior;
  }(r)) return r.behavior(t(e, r));
  var l = "boolean" == typeof r || null == r ? void 0 : r.behavior;
  var _iterator = _createForOfIteratorHelper(t(e, o(r))),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _step.value,
        a = _step$value.el,
        i = _step$value.top,
        s = _step$value.left;
      var _t = i - n.top + n.bottom,
        _o = s - n.left + n.right;
      a.scroll({
        top: _t,
        left: _o,
        behavior: l
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
export { e as default };